{
  "Clear search": "Limpar pesquisa"
}
